// Market dates. Past dates are hidden automatically; when none are left,
// the "Where to find us" section and the "Find us at Markets" link disappear.
export const marketDates = [
  { date: "07th March", event: "Central Avenue West Bridgford", time: "09:30 AM to 3:30 PM", loc: "" },
  { date: "29th March", event: "AY UP MARKET at Old Market Square", time: "11:00 AM to 5:00 PM", loc: "Nottingham NG1 2HU" },
  { date: "11th April", event: "The garage Chilwell", time: "10:00 AM to 02:00 PM", loc: "63 High Rd, Nottingham NG9 4AJ" },

  { date: "02nd May", event: "Central Avenue West Bridgford", time: "09:30 AM to 3:30 PM", loc: "" },
  { date: "09th May", event: "The garage Chilwell", time: "10:00 AM to 02:00 PM", loc: "63 High Rd, Nottingham NG9 4AJ" },
  { date: "04th July", event: "The garage Chilwell", time: "10:00 AM to 02:00 PM", loc: "63 High Rd, Nottingham NG9 4AJ" },
  { date: "05th September", event: "Central Avenue West Bridgford", time: "09:30 AM to 3:30 PM", loc: "" },

  { date: "07th November", event: "Central Avenue West Bridgford", time: "09:30 AM to 3:30 PM", loc: "" },
  { date: "14th November", event: "The garage Chilwell", time: "10:00 AM to 02:00 PM", loc: "63 High Rd, Nottingham NG9 4AJ" }
];

const MONTHS = {
  January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
  July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
};

export const getUpcomingMarketDates = (now = new Date()) =>
  marketDates.filter(item => {
    // Parse e.g. "07th March" or "25th April 2026"; strip the ordinal suffix from the day only
    const [dayStr, monthStr, yearStr] = item.date.replace(/(\d+)(st|nd|rd|th)/, '$1').split(' ');
    const month = MONTHS[monthStr];
    const day = parseInt(dayStr, 10);
    if (month === undefined || Number.isNaN(day)) return true; // can't parse: keep to be safe

    const year = yearStr ? parseInt(yearStr, 10) : now.getFullYear();
    const eventDate = new Date(year, month, day);
    // End of day so events happening today still show
    eventDate.setHours(23, 59, 59, 999);
    return eventDate >= now;
  });
